import { createClient } from '@supabase/supabase-js';
import { config, configProblems } from '../config.js';

export class ConfigError extends Error {
  constructor(problems) {
    super('Application is not configured');
    this.problems = problems;
  }
}

// Session storage adapter: tokens live in sessionStorage (cleared when the browser closes)
// unless the user ticked "Keep me signed in", in which case localStorage is used.
const REMEMBER_KEY = 'ngw.remember';
export const setRememberMe = (remember) => {
  try { window.localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0'); } catch { /* ignore */ }
};
const rememberMe = () => {
  try { return window.localStorage.getItem(REMEMBER_KEY) === '1'; } catch { return false; }
};

const authStorage = {
  getItem: (key) => {
    try { return window.sessionStorage.getItem(key) ?? window.localStorage.getItem(key); } catch { return null; }
  },
  setItem: (key, value) => {
    try {
      const primary = rememberMe() ? window.localStorage : window.sessionStorage;
      const other = rememberMe() ? window.sessionStorage : window.localStorage;
      primary.setItem(key, value);
      other.removeItem(key);
    } catch { /* storage unavailable: session lasts for this page only */ }
  },
  removeItem: (key) => {
    try { window.sessionStorage.removeItem(key); window.localStorage.removeItem(key); } catch { /* ignore */ }
  },
};

let client = null;

export function getSupabase() {
  if (client) return client;
  const problems = configProblems();
  if (problems.length) throw new ConfigError(problems);
  client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: authStorage,
      storageKey: 'ngw-ems-auth',
    },
    global: { headers: { 'x-client-info': 'ngw-ems-web' } },
  });
  return client;
}
